const SANA_PREFIX = 'SANA/';

const CONNECT_WIDGET_MESSAGE = `${SANA_PREFIX}CONNECT` as const;
export const connectWidget = () => ({
  type: CONNECT_WIDGET_MESSAGE,
});

export const CONNECTED_WIDGET_MESSAGE = `${SANA_PREFIX}CONNECTED` as const;
type ConnectedWidgetMessage = {
  type: typeof CONNECTED_WIDGET_MESSAGE;
};

export const USER_ACCESS_TOKEN_WIDGET_MESSAGE = `${SANA_PREFIX}USER_ACCESS_TOKEN` as const;
type UserAccessTokenWidgetMessage = {
  type: typeof USER_ACCESS_TOKEN_WIDGET_MESSAGE;
  payload: {
    userAccessToken: string;
  };
};

export const CULTURE_WIDGET_MESSAGE = `${SANA_PREFIX}CULTURE` as const;
export type Culture = {
  name: string;
};
type CultureWidgetMessage = {
  type: typeof CULTURE_WIDGET_MESSAGE;
  payload: {
    culture: Culture;
  };
};

export type WidgetMessageAction =
  | ConnectedWidgetMessage
  | UserAccessTokenWidgetMessage
  | CultureWidgetMessage;
